import styled, { css } from 'styled-components';

export const Grid = styled.div<{ $gridTemplateColumns?: string; $gap?: string }>(
  ({ $gridTemplateColumns, $gap }) => css`
    display: grid;
    grid-template-columns: ${$gridTemplateColumns ? $gridTemplateColumns : '1fr 1fr'};
    gap: ${$gap ? $gap : '7px 24px'};
  `,
);
